var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',{ref:"password",class:_vm.classes,attrs:{"type":_vm.type,"autocomplete":"off","placeholder":_vm.placeholder},on:{"input":_vm.inputChange},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }